import { useEffect } from 'react'
import useEnrollmentApi from '@hooks/useEnrollmentApi'

const UserDataTracker = () => {
  const { state } = useEnrollmentApi()
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      orderId: state?.id,
      appId: state?.applicationId,
      planSelection: state?.planSelection?.description,
      planPrice: state?.planSelection?.price,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

export default UserDataTracker
